/**
 * 认证工具函数
 */

import { User } from '../types';
import { STORAGE_KEYS } from './constants';

/**
 * 保存 Token 到本地存储
 */
export const saveToken = (token: string): void => {
  localStorage.setItem(STORAGE_KEYS.TOKEN, token);
};

/**
 * 获取 Token
 */
export const getToken = (): string | null => {
  return localStorage.getItem(STORAGE_KEYS.TOKEN);
};

/**
 * 删除 Token
 */
export const removeToken = (): void => {
  localStorage.removeItem(STORAGE_KEYS.TOKEN);
};

/**
 * 保存用户信息
 */
export const saveUser = (user: User): void => {
  localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
};

/**
 * 获取用户信息
 */
export const getUser = (): User | null => {
  const userStr = localStorage.getItem(STORAGE_KEYS.USER);
  if (!userStr) return null;
  
  try {
    return JSON.parse(userStr) as User;
  } catch {
    return null;
  }
};

/**
 * 删除用户信息
 */
export const removeUser = (): void => {
  localStorage.removeItem(STORAGE_KEYS.USER);
};

/**
 * 清除所有认证信息
 */
export const clearAuth = (): void => {
  removeToken();
  removeUser();
};

/**
 * 检查是否已登录
 */
export const isAuthenticated = (): boolean => {
  return !!getToken();
};

/**
 * 检查用户权限
 */
export const hasPermission = (permission: string): boolean => {
  const user = getUser();
  if (!user) return false;
  
  const permissions: Record<string, string[]> = {
    admin: ['read', 'create', 'update', 'delete'],
    editor: ['read', 'create', 'update'],
    viewer: ['read'],
  };
  
  return permissions[user.role]?.includes(permission) || false;
};

